import { useState } from "react";
import { CrearEntidadForm, Input } from "@/components/ui";
import { toastError } from "@/lib/toast";
import type { CrearCecoInput } from "../services/catalogos-contables-admin-service";
import { OrganizacionesPicker } from "./OrganizacionesPicker";

/**
 * Alta de un CeCo · código + nombre + organización(es). Elegir al menos una
 * organización es OBLIGATORIO (relación M:N · el backend lo re-valida).
 */
/** Textos del formulario · por defecto los del CeCo (D-8 lo reusa para cuentas contables). */
export interface CopyElementoConOrgs {
  titulo: string;
  descripcion: string;
  placeholderCodigo: string;
  placeholderNombre: string;
  maxCodigo: number;
}

const COPY_CECO: CopyElementoConOrgs = {
  titulo: "Nuevo Centro de Costo",
  descripcion: "El código funcional es inmutable tras la creación. Debes asignarlo a una o más organizaciones.",
  placeholderCodigo: "CC-001",
  placeholderNombre: "Tesorería",
  maxCodigo: 20,
};

export function CecoCrearForm({
  loading,
  onCrear,
  onCancelar,
  copy = COPY_CECO,
}: {
  loading: boolean;
  onCrear: (input: CrearCecoInput) => void;
  onCancelar: () => void;
  copy?: CopyElementoConOrgs;
}) {
  const [codigo, setCodigo] = useState("");
  const [nombre, setNombre] = useState("");
  const [numerosSociedad, setNumerosSociedad] = useState<string[]>([]);
  const [errorOrg, setErrorOrg] = useState<string>();

  const submit = () => {
    if (!codigo.trim() || !nombre.trim()) {
      toastError({ title: "Datos incompletos", message: "Código y nombre son obligatorios." });
      return;
    }
    if (numerosSociedad.length === 0) {
      setErrorOrg("Selecciona al menos una organización.");
      return;
    }
    setErrorOrg(undefined);
    onCrear({ codigo: codigo.trim(), nombre: nombre.trim(), numerosSociedad });
  };

  return (
    <CrearEntidadForm
      titulo={copy.titulo}
      descripcion={copy.descripcion}
      onCancelar={onCancelar}
      onCrear={submit}
      creando={loading}
    >
      <Input label="Código" placeholder={copy.placeholderCodigo} value={codigo} onChange={(e) => setCodigo(e.currentTarget.value)} maxLength={copy.maxCodigo} className="font-mono" required />
      <Input label="Nombre" placeholder={copy.placeholderNombre} value={nombre} onChange={(e) => setNombre(e.currentTarget.value)} maxLength={160} required />
      <OrganizacionesPicker
        value={numerosSociedad}
        onChange={(v) => {
          setNumerosSociedad(v);
          if (v.length > 0) setErrorOrg(undefined);
        }}
        error={errorOrg}
      />
    </CrearEntidadForm>
  );
}
